import ct from "class-types.macro";
import React, { CSSProperties } from "react";

import {
  FieldError,
  FieldErrors,
  FieldValues,
  Merge,
  FieldErrorsImpl,
} from "react-hook-form";
import { inputErrorMessage, inputErrorMessageFont } from "./inputStyles";

type InputErrorProps = {
  id?: string;
  label: string;
  name: string;
  displayErrorMessage?: boolean;
  errors: FieldErrors<FieldValues>;
  errorPosition?: string;
  requiredText?: string;
  className?: string;
  styles?: CSSProperties;
  overridePosition?: boolean;
  customErrorMessage?: boolean;
};

const InputError = ({
  label,
  name,
  displayErrorMessage = true,
  errors,
  errorPosition,
  requiredText,
  className,
  styles,
  overridePosition = false,
  customErrorMessage = false,
  ...rest
}: InputErrorProps) => {
  const error = errors[name];

  const errorClass =
    (overridePosition ? `${inputErrorMessageFont} ` : `${inputErrorMessage} `) +
    (errorPosition || ct("absolute")) +
    (className ? ` ${className}` : "");

  const renderError = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: FieldError | Merge<FieldError, FieldErrorsImpl<any>>
  ): string => {
    if (typeof error.message === "object") return renderError(error.message);
    if (error?.message === undefined) {
      return "";
    }

    if (error.type === "required" && customErrorMessage) {
      return error.message;
    }

    if (error.type === "required") {
      return requiredText || `${label} is required`;
    }

    if (error.type === "typeError") {
      const typeMatches = error.message.match(/must be a `([A-z]+)` type/);
      if (typeMatches != null && typeMatches.length > 1) {
        return `${label} must be a ${typeMatches[1]}`;
      }
    }

    return error.message;
  };

  return (
    <>
      {displayErrorMessage && error && (
        <span
          id={`${name}Error`}
          style={styles}
          className={`${errorClass}`}
          role="alert"
          {...rest}
        >
          {renderError(error)}
        </span>
      )}
    </>
  );
};

export default InputError;
